<template>
    <div class="designing-screen" :class="activeStep === 1 ? 'step-bg-teal' : 'step-bg-white'">
        <PreviewPage v-if="activeStep === 6" class="preview-overlay" @back="handlePreviewBack" @restart="handlePreviewRestart" />
        <div class="screen-content" v-show="activeStep !== 6">
            <div class="controls-upper">
                <div class="hstack justify-content-between gap-4 px-4 flex-grow-1">
                    <FadeInOut mode="out-in" :duration="200">
                        <div v-if="activeStep === 1" class="hstack justify-content-center position-relative flex-grow-1">
                            <button class="btn btn-none p-0 position-absolute start-0" @click="backToPreviousStep">
                                <Icon symbol="chevron-left"></Icon>
                            </button>
                            <p class="heading-s mb-0 text-center">Pilih Gambar Latar</p>
                        </div>
                        <div v-if="activeStep === 2" class="hstack justify-content-center position-relative flex-grow-1">
                            <button class="btn btn-none p-0 position-absolute start-0" @click="backToPreviousStep">
                                <Icon symbol="chevron-left"></Icon>
                            </button>
                            <p v-if="!selectedMediaType" class="heading-s mb-0">Format Pilihan Kad e-Ucapan</p>
                            <p v-else class="heading-s mb-0">Ambil atau Pilih Gambar</p>
                        </div>
                        <div v-if="activeStep === 3" class="hstack justify-content-center position-relative flex-grow-1">
                            <button v-if="!selectedMediaType" class="btn btn-none p-0 position-absolute start-0" @click="backToPreviousStep">
                                <Icon symbol="chevron-left"></Icon>
                            </button>
                            <p class="heading-s mb-0">Susun Gambar Anda</p>
                        </div>
                        <div v-if="activeStep === 4" class="hstack justify-content-center position-relative flex-grow-1">
                            <button class="btn btn-none p-0 position-absolute start-0" @click="backToPreviousStep">
                                <Icon symbol="chevron-left"></Icon>
                            </button>
                            <p class="heading-s mb-0">Masukkan Nama Anda</p>
                        </div>
                        <div v-if="activeStep === 5" class="hstack justify-content-center position-relative flex-grow-1">
                            <button class="btn btn-none p-0 position-absolute start-0" @click="backToPreviousStep">
                                <Icon symbol="chevron-left"></Icon>
                            </button>
                            <p class="heading-s mb-0">Masukkan Nama Anda</p>
                        </div>
                        <div v-if="activeStep === 6" class="hstack justify-content-center position-relative flex-grow-1">
                            <button class="btn btn-none p-0 position-absolute start-0" @click="handlePreviewBack">
                                <Icon symbol="chevron-left"></Icon>
                            </button>
                        </div>
                    </FadeInOut>
                </div>
            </div>
            <div ref="canvasContainerRef" class="canvas-content position-relative"
                :style="{ height: scaledCanvasHeight + 'px', minHeight: scaledCanvasHeight + 'px', overflow: 'hidden' }">
                <div :style="{
                    transform: `scale(${canvasScale})`,
                    transformOrigin: 'top left',
                    width: postCardDimensionSettings.width + 'px',
                    height: postCardDimensionSettings.height + 'px',
                    marginLeft: ((containerWidth - postCardDimensionSettings.width * canvasScale) / 2) + 'px'
                }">
                    <FabricCanvas></FabricCanvas>
                </div>
            </div>
            <div class="controls-bottom">
                <!-- <FadeInOut mode="out-in" :duration="300"> -->
                <DesignAddBackground v-if="activeStep === 1" @next="nextStepHandler" :assets="assets">
                </DesignAddBackground>
                <DesignAddMedia v-if="activeStep === 2" @next="nextStepHandler">
                </DesignAddMedia>
                <DesignAddMediaPreview v-if="activeStep === 3" @next="nextStepHandler" @back="backToPreviousStep">
                </DesignAddMediaPreview>
                <DesignAddText v-if="activeStep === 4" @next="nextStepHandler">
                </DesignAddText>
                <DesignStaticAddText v-if="activeStep === 5" @generate-preview="createPreview"></DesignStaticAddText>
                <!-- </FadeInOut> -->
            </div>
        </div>

        <div class="debug d-none">
            <div class="overflow-hidden">
                <video ref="recordStreamCamRef" id="record-stream-cam" :width="postCardDimensionSettings.width"
                    :height="postCardDimensionSettings.height" controls playsinline></video>
            </div>
            <!-- <audio ref="audioRayaTheme1Ref" id="audio" src="/mp3/music-one.mp3" controls playsinline></audio>
            <audio ref="audioRayaTheme2Ref" id="audio" src="/mp3/music-two.mp3" controls playsinline></audio> -->
        </div>

        <Teleport to="#teleportModals">
            <VueRecaptcha v-if="!appConstants.GRECAPTCHA_DISABLED"
            ref="recaptchaRef" class="visibility-hidden"
                :sitekey="appConstants.GRECAPTCHA_SITE_KEY" :size="'invisible'" @verify="onVerify" badge="bottomleft">
            </VueRecaptcha>
        </Teleport>

    </div>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted, ref, computed, nextTick } from 'vue';
import { FadeInOut } from "vue3-transitions";
import DesignAddBackground from './design-add-background.vue';
import DesignAddMedia from './design-add-media.vue';
import DesignAddMediaPreview from './design-add-media-preview.vue';
import DesignAddText from './design-add-text.vue';
import FabricCanvas from '../fabric-canvas.vue';
import { Icon } from '@/modules/core/components';
import { useDesignStore, usePreviewStore } from '../../stores';
import { storeToRefs } from 'pinia';
import useFabricCanvas from '../../composables/use-fabric-canvas';
import { fabric } from "fabric";
import appConstants from '@/modules/website/app.constants';
import { VueRecaptcha } from 'vue-recaptcha';
import { scrollIntoView } from "seamless-scroll-polyfill";
import DesignStaticAddText from './design-static-add-text.vue';
import PreviewPage from '../preview/preview-page.vue';


const emits = defineEmits(['back', 'continue']);
defineProps({
    assets: {
        type: Array<fabric.Sprite>,
        required: true,
    }
})

const activeStep = ref(1);
const canvasContainerRef = ref<HTMLElement>();
const containerWidth = ref(0);

const canvasScale = computed(() => {
    const canvasWidth = postCardDimensionSettings.value.width;
    if (!canvasWidth || !containerWidth.value) return 1;
    return Math.min(1, containerWidth.value / canvasWidth);
});

const scaledCanvasHeight = computed(() => {
    return postCardDimensionSettings.value.height * canvasScale.value;
});

const previewStore = usePreviewStore();
const { recordStreamCamRef, audioRayaTheme1Ref, audioRayaTheme2Ref, videoFileType, selectedMediaType, isRecordingWebCam } = storeToRefs(previewStore);


const designStore = useDesignStore();
const { selectedTheme, isBusy, postCardDimensionSettings } = storeToRefs(designStore);
const recaptchaRef = ref<InstanceType<typeof VueRecaptcha>>();

const nextStepHandler = async () => {

    if (activeStep.value === 4) {
        return createPreview();
    }

    if (selectedTheme.value === 1) {
        return activeStep.value = 5;
    }

    ++activeStep.value;
}

const handlePreviewBack = () => {
    activeStep.value = selectedTheme.value === 1 ? 5 : 4;
}

const handlePreviewRestart = () => {
    emits('back');
}

const backToPreviousStep = () => {

    if (isRecordingWebCam.value) return;

    if (activeStep.value === 1) emits('back');

    const [canvas] = useFabricCanvas();

    canvas.discardActiveObject();
    canvas.renderAll();

    if (activeStep.value === 4) {
        designStore.undo();

        // design undo here doesn't seem undo the texbox we created, thus need manually remove from the object list in canvas fabric.
        designStore.removeFabricCanvasElement('textbox-element');
    } else if(activeStep.value === 2) {
        selectedMediaType.value = null;
    } else if (selectedTheme.value === 1){
        return activeStep.value = 1;
    }

    --activeStep.value;
}

const createPreview = async () => {
    if (!appConstants.GRECAPTCHA_DISABLED) {
        recaptchaRef.value?.execute()
        return;
    }

    onVerify();
}

const onVerify = async (recaptchaResponse?: string) => {
    try {
        isBusy.value = true;

        // if (selectedTheme.value !== 1) {
        //     await previewStore.generateVideoPreviewTry2();

        //     if (videoFileType.value === 'webm') {
        //         await previewStore.transcodeVideo(recaptchaResponse);
        //     }
        // } else {
            await previewStore.generateImagePreview();
        // }

        isBusy.value = false;

        activeStep.value = 6;
    } finally {
        recaptchaRef.value?.reset();
    }
}

const scrollTo = (direction: 'top' | 'bottom') => {
    const topEl = document.querySelector('.controls-upper')!;
    const btmEl = document.querySelector('.controls-bottom')!;
    scrollIntoView(direction === 'top' ? topEl : btmEl, { behavior: 'smooth', block: 'start' })
}

const updateContainerWidth = () => {
    // Measure from .main-screen which has a stable width unaffected by scrollbar/content
    const mainScreen = canvasContainerRef.value?.closest('.main-screen') as HTMLElement | null;
    if (mainScreen && mainScreen.clientWidth > 0) {
        containerWidth.value = mainScreen.clientWidth;
    } else {
        containerWidth.value = Math.min(window.innerWidth * 0.9, 428);
    }
};

onMounted(async () => {
    await nextTick();
    updateContainerWidth();
    window.addEventListener('resize', updateContainerWidth);

    window.scrollTo({
        top: 60,
        behavior: "smooth",
    });
})

onUnmounted(() => {
    window.removeEventListener('resize', updateContainerWidth);
})

</script>

<style lang="scss">
.designing-screen {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    background-position: top center, bottom center;
    background-repeat: no-repeat, no-repeat;
    background-size: 100% auto, 100% auto;

    &.step-bg-teal {
        background-image: url('/images/prubsn/layout/frame.png'), url('/images/prubsn/layout/frame.png');
    }

    &.step-bg-white {
        background-image: url('/images/prubsn/layout/frame.png'), url('/images/prubsn/layout/frame-white.png');
    }

    .preview-overlay {
        position: absolute;
        inset: 0;
        z-index: 10;
    }

    .screen-content {
        z-index: 1;
        display: flex;
        flex-direction: column;
        flex: 1;
        min-height: 0;
        overflow-y: auto;
    }

    .controls-upper {
        display: flex;

        .hstack > div {
            margin-top: 15px;
            margin-bottom: 15px;
        }

        p {
            font-size: 20px;
            font-weight: 700;
        }
    }

    .controls-bottom {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
    }

    @include media-breakpoint-up(md) {
        height: 750px;
    }

}

.grecaptcha-badge {
    visibility: hidden;
    opacity: 0;
}
</style>
